import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/Damodaran.png";
const icon2 = "https://winpeforum.com/assets/elements/RadhikaHaribhakti.jpg";
const icon3 = "https://winpeforum.com/assets/elements/AshuSuyash.jpg";
 

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker2 = [
     
  
  
        {
          imgUrl: icon1,
          desc: `<div>
M. Damodaran, IAS (Retd.), presently a governance consultant, advisor, mentor and coach, has worked
with the Union and the State governments in India, regulatory bodies, investment institutions, banks,
development financial institutions and with the private sector. He has headed the highly successful
restructuring efforts in Unit Trust of India (UTI) and Industrial Development Bank of India (IDBI). He has
been the Chairman of Securities and Exchange Board of India (SEBI). During his tenure at SEBI, he was
elected Chairman of the EMC of the International Organisation of Securities Commission (IOSCO).
He has chaired high powered committees of the Government of India, Reserve Bank of India (RBI) and
some chambers of commerce. He has won several awards, including some for governance, leadership
and transformation. He has been on the Boards of some of India’s biggest companies and on the
<br/><br/>
Advisory Boards of some foreign entities and is the Founder Chairman of Indian Institute of Management
(IIM), Tiruchirappalli. He graduated with distinction in Economics and in Law from the Universities of
Madras and Delhi respectively. He is widely acknowledged as one of India’s foremost champions of
Corporate Governance and is passionate about improving Board performance.
 
          </div>`,
          name: "M. Damodaran",
          post: `<div>Founder & Chairperson<br/> Excellence Enablers

          </div>`,
        },
  ];
    this.Speaker1 = [
   {
            imgUrl: icon3,
          desc: `<div>
    Ashu Suyash is a seasoned leader with over 30 years of experience across Indian financial services and
global information sectors. She is the Founder &amp; CEO of Colossa Ventures, an investment platform
empowering women-led businesses with capital, capability, and confidence.<Br/><br/>
She serves as an independent director on the boards of Hindustan Unilever, Kotak Mahindra Bank, and
Tata Elxsi.<br/><br/>
Ashu is a strong sponsor of governance and best practices, and cares deeply about economic agency for
women, affordable healthcare and right to education for all. She is a member of several Associations and
Committees in these areas. Ashu has received several awards and has been recognised among the Top
50 Women in business in India. She is a Chartered Accountant and holds a bachelor&#39;s degree in
commerce from University of Mumbai.
          </div>`,
          name: "Ashu Suyash",
          post: `<div>Director on Boards
          </div>`,
          },
              {
          imgUrl: icon1,
          desc: `<div>
M. Damodaran, IAS (Retd.), presently a governance consultant, advisor, mentor and coach, has worked
with the Union and the State governments in India, regulatory bodies, investment institutions, banks,
development financial institutions and with the private sector. He has headed the highly successful
restructuring efforts in Unit Trust of India (UTI) and Industrial Development Bank of India (IDBI). He has
been the Chairman of Securities and Exchange Board of India (SEBI). During his tenure at SEBI, he was
elected Chairman of the EMC of the International Organisation of Securities Commission (IOSCO).
He has chaired high powered committees of the Government of India, Reserve Bank of India (RBI) and
some chambers of commerce. He has won several awards, including some for governance, leadership
and transformation. He has been on the Boards of some of India’s biggest companies and on the
<br/><br/>
Advisory Boards of some foreign entities and is the Founder Chairman of Indian Institute of Management
(IIM), Tiruchirappalli. He graduated with distinction in Economics and in Law from the Universities of
Madras and Delhi respectively. He is widely acknowledged as one of India’s foremost champions of
Corporate Governance and is passionate about improving Board performance.
 
          </div>`,
          name: "M. Damodaran",
          post: `<div>Founder & Chairperson<br/> Excellence Enablers

          </div>`,
        },
        {
            imgUrl: icon2,
          desc: `<div>
    Radhika Haribhakti has over 30 years of experience in commercial and investment banking, having
worked with Bank of America, JM Morgan Stanley, and DSP Merrill Lynch. She has advised several giant
corporates and led their equity and debt offerings in domestic and international capital markets. She
currently provides advisory services at RH Financial. <br/><br/>
She serves as an Independent Director on the Boards of Torrent Power, Bajaj Finance, Bajaj Finserv,
ICRA, NOCIL, and Data Link Investment Manager.<br/><br/>

Radhika Haribhakti has been closely associated with women empowerment and financial inclusion and
has over 18 years of experience serving on non-profit boards. She is the former Chair of Friends of
Women&#39;s World Banking (FWWB) and Swadhaar FinAccess, two non-profits engaged in providing
financial solutions to women in economically disadvantaged communities. She also previously served on
the Governing Council of Citigroup Micro Enterprise Award and CIl&#39;s National Committee on Women
Empowerment.
          </div>`,
          name: "Radhika Haribhakti",
          post: `<div>Director on Boards
          </div>`,
          },
          
            
           
          
    ];
 
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Connect with Winpe"
          image={"https://winpeforum.com/assets/wob/banner.jpg"}
          description="Join the Winpe WhatsApp groups to be a part of the largest community of women in PEVC. These groups allow women to connect, exchange insights with peers, stay updated on the latest PEVC market trends and hear about exclusive events."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            
            <div className="toastshine_section">
              <div className="m_heading">
Connect with Winpe
              </div>
              <div className="r_btm"></div>
               
  
              <br/>
 
 
              <div className="top_text" style={{textAlign: 'justify'}}> 
          
  
<p>
            
Join the Winpe WhatsApp groups to be a part of the largest community of women in PEVC. These groups allow women to connect, exchange insights with peers, stay updated on the latest PEVC market trends and hear about exclusive events. It provides a safe space to discuss challenges, celebrate wins, support each other and openly discuss workplace issues, diversity challenges, and best practices in a trusted environment. Professionals also explore potential collaborations, co-investments, and partnerships. Plus, you’ll always be in the loop on the latest from Winpe! 
<br/><br/>
Find the WhatsApp groups you want to join —let’s grow this network together! 
<br/><br/>
Join the Mumbai WhatsApp group to connect, collaborate, and network with women in PEVC across the city:<br/> 
<b>Winpe Mumbai: </b><br/> 
<a  style={{color:'#bf2026'}} href="https://chat.whatsapp.com/BT7Ju1vK1vBGMeIbUDpSkQ">https://chat.whatsapp.com/BT7Ju1vK1vBGMeIbUDpSkQ</a>
<br/><br/>
Join the Delhi WhatsApp group to connect, collaborate, and network with women in PEVC across the city:<br/> 
<b>Winpe Delhi: </b><br/>
<a  style={{color:'#bf2026'}} href="https://chat.whatsapp.com/IPKFFU0P5PyH3HGZY8Cm9v">https://chat.whatsapp.com/IPKFFU0P5PyH3HGZY8Cm9v</a>
<br/><br/>
Join the Bangalore WhatsApp group to connect, collaborate, and network with women in PEVC across the city:
<br/><b>Winpe Bangalore:</b><br/>
<a  style={{color:'#bf2026'}} href="https://chat.whatsapp.com/Er0BSA3ObZsA2XSJwWN6Tl">https://chat.whatsapp.com/Er0BSA3ObZsA2XSJwWN6Tl</a>
<br/><br/>

<h3>Career Network Group </h3>

Career Network Group is a part of Ignite by Winpe, a platform designed to support the female talent pipeline in the Private Equity and Venture Capital (PEVC) industry. <br/><br/>
Ignite offers online career sessions, masterclasses, job vacancy information, and a profile bank of women interested in PEVC roles—accessible to 30+ member firms in an anonymized format. So when PEVC firms hire, they can access our profile repository for candidates. The profile bank is open to women at all levels, including those already in PEVC and– as mentioned, we hide the candidate and firm names in the database that is shared with hiring firms. <br/><br/>
Join the Winpe Career Network WhatsApp group to keep yourself updated on our career sessions, receive information on job openings which we keep posting there and join the Winpe Ignite profile repository.<br/><br/>
Here is the link to the Winpe Career Network Group:<br/>
<a style={{color:'#bf2026'}} href="https://chat.whatsapp.com/JeAI8cBNsvSBtwY5jzNk6Y">https://chat.whatsapp.com/JeAI8cBNsvSBtwY5jzNk6Y</a>

<br/><br/><br/>
<h3>Winpe Women on Boards</h3>

Women on Boards is focused on strengthening boardrooms through greater representation of accomplished women leaders.
 
The Women on Boards whatsapp group is a platform for sharing insights, updates, and relevant perspectives on board opportunities, governance, and regulatory developments.<br/><br/>
Join the Women on Board whatsapp groups:<br/>
<a style={{color:'#bf2026'}} href="https://chat.whatsapp.com/Jlema24oL2sJ2aDUUFREDa?mode=gi_t">https://chat.whatsapp.com/Jlema24oL2sJ2aDUUFREDa?mode=gi_t</a>

<br/><br/><br/>

</p>
              </div>
 

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/whatsappgroups/index.js